/** صفحهٔ عمومیِ لینک «Block sender» در ایمیل دعوت. */
import React, { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { Link, useParams } from 'react-router-dom';
import { publicInviteRepo } from '@/core/data/inviteRepo';
import { reportError } from '@/core/lib/report';
import { Card } from '@/ui/kit';

export function BlockSenderPage() {
  const { token } = useParams<{ token: string }>();
  const [invalid, setInvalid] = useState(false);
  const block = useMutation({
    mutationFn: () => publicInviteRepo.blockSender(token!),
    onSuccess: (ok) => setInvalid(!ok),
    onError: (error) => {
      reportError('web.blockInviteSender', error);
      setInvalid(true);
    },
  });

  const done = block.isSuccess && !invalid;
  return (
    <div className="feed guest">
      <Card>
        <h1 className="feed-title">{done ? 'Sender blocked' : 'Block this sender?'}</h1>
        {done ? (
          <p>You won’t receive any more WhosUp invitations from this person at this email address.</p>
        ) : invalid || !token ? (
          <p>This link is invalid. Nothing was changed.</p>
        ) : (
          <>
            <p>This email address won’t receive any more WhosUp invitations from this person.</p>
            <button type="button" className="btn fill block"
              disabled={block.isPending} onClick={() => block.mutate()}>
              {block.isPending ? 'Blocking…' : 'Block sender'}
            </button>
          </>
        )}
        <p className="dim"><Link to="/">Back to WhosUp</Link></p>
      </Card>
    </div>
  );
}
